(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-clock-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shftd-countdown-v2')) {
    // One shared 1s clock for every countdown on the page.
    const live = new Set();
    let clock = null;

    const startClock = () => {
      if (clock === null) {
        clock = window.setInterval(() => {
          // Snapshot: an expiring countdown removes itself in _tick.
          Array.from(live).forEach((el) => el._tick());
        }, 1000);
      }
    };

    const stopClockIfIdle = () => {
      if (clock !== null && live.size === 0) {
        window.clearInterval(clock);
        clock = null;
      }
    };

    const UNITS = ['days', 'hours', 'minutes', 'seconds'];
    const pad = (n) => String(n).padStart(2, '0');

    class ShftdCountdownV2 extends HTMLElement {
      connectedCallback() {
        // The editor can move a section's DOM and re-run this callback.
        this._stop();

        this._section = this.closest('.shftd-section');
        this._nums = {};
        this._shown = {};
        this.querySelectorAll('[data-unit]').forEach((unit) => {
          this._nums[unit.dataset.unit] = unit.querySelector('.clock__num');
        });

        // Bail silently: the server-rendered digits stay on screen.
        const epoch = parseInt(this.dataset.targetEpoch, 10);
        if (isNaN(epoch) || epoch <= 0) return;

        this._target = epoch * 1000;

        // Visitor-timezone mode: re-read the zoneless string in the browser's
        // own zone, the way the past-winners-hall teaser clock does.
        let local = (this.dataset.targetLocal || '').trim();
        if (local) {
          if (/^\d{4}-\d{2}-\d{2}$/.test(local)) local += 'T23:59:59';
          const parsed = new Date(local).getTime();
          if (!isNaN(parsed)) this._target = parsed;
        }
        this._onEnded = this.dataset.onEnded || 'text';
        this._urgentMs = (parseInt(this.dataset.urgentHours, 10) || 0) * 3600000;
        this._hideZeroDays = this.dataset.hideZeroDays === 'true';
        this._done = false;

        // Straight away, so a stale cached frame is corrected before the
        // first interval fires.
        this._tick();

        // An already-expired countdown must not enter the shared clock.
        if (!this._done) {
          live.add(this);
          startClock();
        }
      }

      disconnectedCallback() {
        this._stop();
      }

      _stop() {
        live.delete(this);
        stopClockIfIdle();
      }

      _set(unit, value) {
        const el = this._nums[unit];
        if (!el || this._shown[unit] === value) return;
        this._shown[unit] = value;
        el.textContent = value;
      }

      _expire() {
        this._done = true;
        UNITS.forEach((unit) => this._set(unit, '00'));

        // Both hides are ignored in the editor: dropping the block or the
        // section there would take away what the merchant is configuring.
        const editor = window.Shopify && window.Shopify.designMode;
        if (this._onEnded === 'hide_section' && !editor && this._section) {
          this._section.classList.add('is-ended-hidden');
        } else if (this._onEnded === 'hide_block' && !editor) {
          this.classList.add('is-ended-hidden');
        } else {
          this.classList.add('is-ended');
        }
        this._stop();
      }

      _tick() {
        const remaining = this._target - Date.now();
        if (remaining <= 0) {
          this._expire();
          return;
        }

        // The server may have called it ended on the shop's clock while the
        // visitor's zone is still open.
        this.classList.remove('is-ended');

        const total = Math.floor(remaining / 1000);
        const days = Math.floor(total / 86400);
        this._set('days', pad(days));
        this._set('hours', pad(Math.floor((total % 86400) / 3600)));
        this._set('minutes', pad(Math.floor((total % 3600) / 60)));
        this._set('seconds', pad(total % 60));

        if (this._hideZeroDays) {
          this.classList.toggle('is-no-days', days === 0);
        }
        if (this._urgentMs > 0) {
          this.classList.toggle('is-urgent', remaining <= this._urgentMs);
        }
      }
    }
    customElements.define('shftd-countdown-v2', ShftdCountdownV2);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shftd-product-card')) {
    class ShftdProductCard extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        const signal = this._abort.signal;

        /* Warm the variant images on intent (hover/touch/focus), not on page
           load — the later click swap then resolves from the HTTP cache. */
        this._warm = () => {
          if (this._warmed) return;
          this._warmed = true;
          this.querySelectorAll('[data-swatch][data-image]').forEach((swatch) => {
            const img = new Image();
            img.src = swatch.dataset.image;
          });
        };
        this.addEventListener('mouseenter', this._warm, { signal });
        this.addEventListener('touchstart', this._warm, { passive: true, signal });
        this.addEventListener('focusin', this._warm, { signal });

        this.addEventListener(
          'click',
          (e) => {
            const swatch = e.target.closest('[data-swatch]');
            if (!swatch) return;
            e.preventDefault();
            e.stopPropagation();
            const img = this.querySelector('img.pcard__img');
            if (img && swatch.dataset.image) {
              img.removeAttribute('srcset');
              img.src = swatch.dataset.image;
            }
            const link = this.querySelector('.pcard__link');
            if (link && swatch.dataset.url) link.href = swatch.dataset.url;
            this.querySelectorAll('[data-swatch].is-active').forEach((el) => el.classList.remove('is-active'));
            swatch.classList.add('is-active');
          },
          { signal: this._abort.signal }
        );
      }
      disconnectedCallback() {
        this._abort.abort();
      }
    }
    customElements.define('shftd-product-card', ShftdProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shftd-carousel')) {
    class ShftdCarousel extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-carousel-track]');
        this._prev = this.querySelector('[data-carousel-prev]');
        this._next = this.querySelector('[data-carousel-next]');
        if (!this._track) return;

        this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._ticking = false;
        this._update = () => {
          const t = this._track;
          const scrollable = t.scrollWidth > t.clientWidth + 1;
          if (this._prev) this._prev.hidden = !scrollable;
          if (this._next) this._next.hidden = !scrollable;
          if (!scrollable) return;
          if (this._prev) this._prev.disabled = t.scrollLeft <= 1;
          if (this._next) this._next.disabled = t.scrollLeft >= t.scrollWidth - t.clientWidth - 1;
        };
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          requestAnimationFrame(() => {
            this._update();
            this._ticking = false;
          });
        };
        this._onClick = (dir) => {
          this._track.scrollBy({
            left: dir * this._track.clientWidth,
            behavior: this._reduced.matches ? 'auto' : 'smooth',
          });
        };
        this._onPrev = () => this._onClick(-1);
        this._onNext = () => this._onClick(1);

        if (this._prev) this._prev.addEventListener('click', this._onPrev);
        if (this._next) this._next.addEventListener('click', this._onNext);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        this._ro = new ResizeObserver(this._onScroll);
        this._ro.observe(this._track);
        this._update();
      }

      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
        if (this._track) this._track.removeEventListener('scroll', this._onScroll);
        if (this._prev) this._prev.removeEventListener('click', this._onPrev);
        if (this._next) this._next.removeEventListener('click', this._onNext);
      }
    }
    customElements.define('shftd-carousel', ShftdCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["progress-block-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shftd-pgbar')) {
    class ShftdPgbar extends HTMLElement {
      connectedCallback() {
        // A re-render in the theme editor reconnects the element: start
        // clean so the fill replays from zero instead of keeping a stale state.
        this.classList.remove('is-armed', 'is-in');
        if (this._io) this._io.disconnect();
        this._io = null;

        if (!this.hasAttribute('data-animate')) return;
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Park the fill at 0 and commit that style before observing, so the
        // transition to the real width has a start value to run from.
        this.classList.add('is-armed');
        void this.offsetWidth;

        this._io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-in');
            if (this._io) this._io.disconnect();
            this._io = null;
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        this._io = null;
      }
    }
    customElements.define('shftd-pgbar', ShftdPgbar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shftd-sizeguide')) {
    class ShftdSizeGuide extends HTMLElement {
      connectedCallback() {
        /* Portal to <body>: the drawer renders inside the buy column, where
           the blurred sticky header can composite above even a higher
           z-index — from body it sits in the root stacking context and wins
           outright. The move re-runs this callback; the orphan sweep keeps
           theme-editor re-renders from stacking up dead instances. */
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > shftd-sizeguide').forEach((el) => el.remove());
          document.body.appendChild(this);
          return;
        }

        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._panel = this.querySelector('.sgv2__panel');

        /* Document-level so any [data-sizeguide-open] trigger works — the
           variant picker's label lives outside this element. */
        document.addEventListener(
          'click',
          (e) => {
            if (e.target.closest('[data-sizeguide-open]')) {
              e.preventDefault();
              this.open();
              return;
            }
            if (this.contains(e.target) && e.target.closest('[data-sg-close]')) this.close();
          },
          { signal }
        );

        /* Close controls ALSO get direct listeners: iOS Safari only
           synthesizes click events for taps on elements it considers
           clickable, and a delegated listener on document does not qualify a
           plain <div> scrim. A listener bound on the element itself does. */
        this.querySelectorAll('[data-sg-close]').forEach((el) => {
          el.addEventListener('click', () => this.close(), { signal });
        });
        /* Pointer fallback on the scrim — pointer events are delivered on
           every engine regardless of click-synthesis heuristics. */
        const scrim = this.querySelector('.sgv2__scrim');
        if (scrim) {
          scrim.addEventListener(
            'pointerup',
            (e) => {
              if (e.target === scrim) this.close();
            },
            { signal }
          );
        }

        document.addEventListener(
          'keydown',
          (e) => {
            /* LIFO Escape: shftdEscHandled means a higher overlay already
               consumed this press; the zoom check covers the case where our
               handler happens to run before the gallery's. */
            if (
              e.key === 'Escape'
              && !e.shftdEscHandled
              && this.hasAttribute('data-open')
              && !document.querySelector('.pdp__zoom:not([hidden])')
            ) {
              e.shftdEscHandled = true;
              this.close();
            }
          },
          { signal }
        );

        this.addEventListener(
          'click',
          (e) => {
            const tab = e.target.closest('[data-sg-tab]');
            if (!tab) return;
            const key = tab.dataset.sgTab;
            this.querySelectorAll('[data-sg-tab]').forEach((t) => {
              const on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            this.querySelectorAll('[data-sg-pane]').forEach((p) => {
              p.hidden = p.dataset.sgPane !== key;
            });
          },
          { signal }
        );
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        /* Removed while open (orphan sweep, editor re-render): release the
           scroll lock so the page can never stay frozen. */
        this._unlockScroll();
      }

      /* Refcounted scroll lock shared across v2 overlays via
         html[data-shftd-locks] — see cart-drawer-v2 for the rationale:
         snapshot-restore resurrects stale 'hidden' when overlays close in
         non-LIFO order; a counter releases exactly when the last one closes. */
      _lockScroll() {
        if (this._holdsLock) return;
        this._holdsLock = true;
        const html = document.documentElement;
        html.dataset.shftdLocks = String((parseInt(html.dataset.shftdLocks, 10) || 0) + 1);
        html.style.overflow = 'hidden';
      }

      _unlockScroll() {
        if (!this._holdsLock) return;
        this._holdsLock = false;
        const html = document.documentElement;
        const n = Math.max(0, (parseInt(html.dataset.shftdLocks, 10) || 1) - 1);
        if (n === 0) {
          delete html.dataset.shftdLocks;
          html.style.overflow = '';
        } else {
          html.dataset.shftdLocks = String(n);
        }
      }

      open() {
        if (this.hasAttribute('data-open')) return;
        this.setAttribute('data-open', '');
        this._prevFocus = document.activeElement;
        this._lockScroll();
        /* Focus lands on the close button, not the panel: the exit is one
           Enter away, and assistive tech starts on the way out. */
        const closeBtn = this.querySelector('button[data-sg-close]');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
        else if (this._panel) this._panel.focus({ preventScroll: true });
      }

      close() {
        if (!this.hasAttribute('data-open')) return;
        this.removeAttribute('data-open');
        this._unlockScroll();
        if (this._prevFocus && this._prevFocus.focus) this._prevFocus.focus({ preventScroll: true });
      }
    }
    customElements.define('shftd-sizeguide', ShftdSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
